import { useState } from "react"
import { toast } from 'react-hot-toast';
import Loader from "../../Common/Loader";
import SystemModal from "../../Common/SystemModal";
import ajaxStation from "../../../util/remote/ajaxStation";


const DisableAuthMethod=(props)=>{

    const [loading, setLoading] = useState(false)

    const handleUpdate = async(e) =>{
        e.preventDefault()
        setLoading(true)
        const server_response = await ajaxStation.disableAuthMethod(props.settingID);
        setLoading(false);
        if(server_response.status==="OK"){
            toast.success(server_response.message);
            props.g()
            props.h();
            props.i();
        }
        else{
            toast.error(server_response.message); 
        } 
    }
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    <button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleUpdate}>Confirm<i class="fas fa-check mg-l-15"></i></button>
                    </>
        }
    }

    return(
        <SystemModal
            title="Disable Authentication Method"
            id="model-disable-auth"
            size="md"
            footer={RenderFooter}
        >

        <div className="row">
        <div className="bg-white">
                <div className="alert text-center">
                    <i className="fe fe-alert-circle fs-50 text-warning" style={{fontSize:"50px"}}></i>
                    <h3 className="mt-2 mb-1">Are you sure you want to disable this authentication method?</h3>
                    <p className="mb-3 mb-3 tx-inverse">This authentication method will now be disabled.</p>
                </div>
            </div>
        </div>
       
        </SystemModal>
    )
}

export default DisableAuthMethod
